<template>
  <div
    :class="[
      isValidPassAndCenteredQR ? 'centered-qr-content' : 'default-content',
    ]"
  >
    <div v-if="isValidPassAndCenteredQR" class="centered-qr-ticket-name-label">
      <CenteredQRTicketNameLabel
        :is-valid-pass-and-centered-q-r="isValidPassAndCenteredQR"
        :pass-name="pass.name"
        :upper-colors="upperColors"
      />
    </div>

    <div class="column">
      <!-- 利用区間-->
      <BFaceSectionDisp
        v-if="book.price"
        :class="{ 'centered-qr-b-face-section-disp': isValidPassAndCenteredQR }"
        :price="book.price"
        :display-section-type="pass.display_section_type"
        :is-return-trip="pass.is_return_trip"
        :is-valid-pass-and-centered-q-r="isValidPassAndCenteredQR"
      />
    </div>

    <div class="column">
      <!-- division毎の購入枚数の表示 -->
      <BgFaceDivisionCountDisp
        :class="{
          'centered-qr-bg-face-division-count-disp': isValidPassAndCenteredQR,
        }"
        :divisions="divisions"
        :is-valid-pass-and-centered-q-r="isValidPassAndCenteredQR"
      />
    </div>

    <!-- 有効期間-->
    <div class="column">
      <!-- 有効化前 開始〜終了期間 -->
      <div v-if="pass.is_valid == false">
        <BFaceAvailablePeriodDisp
          v-if="book.user_started_at"
          :start="book.user_started_at"
          :limit="limitedAtMinusStartHour"
        />
        <!-- book.user_started_atがない場合、book.available_started_atを使用 -->
        <BFaceAvailablePeriodDisp
          v-else
          :start="book.available_started_at"
          :limit="limitedAtMinusStartHour"
        />
      </div>

      <!-- 有効化後 -->
      <div v-else>
        <!-- 開始〜終了期間（Centered QR版） -->
        <BFaceCenteredQRAvailablePeriodDisp
          v-if="!isCountdownType && isValidPassAndCenteredQR"
          :start="pass.user_started_at"
          :limit="limitedAtMinusStartHour"
        />

        <!-- 開始〜終了期間（デフォルト版） -->
        <BFaceAvailablePeriodDisp
          v-else-if="!isCountdownType"
          :start="pass.user_started_at"
          :limit="limitedAtMinusStartHour"
          :is-valid-pass-and-centered-q-r="isValidPassAndCenteredQR"
        />

        <!-- 利用期限(カウントダウン表示する一部チケットのみ) -->
        <PFaceUseEndPeriod v-else :limit="pass.user_limited_at" />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";

import bookGroupService from "@/services/bookGroup";
import myTicketsCommonService from "@/services/common/myTickets";
import passService from "@/services/pass";

export default {
  name: "ThePassUpper",
  props: {
    headerTitle: {
      type: String,
      required: false,
    },
    isValidPassAndCenteredQR: {
      type: Boolean,
      required: true,
    },
    isCenteredQR: {
      type: Boolean,
      required: false,
      default: false,
    },
    upperColors: {
      type: Object,
      required: false,
    },
  },
  setup(props) {
    const store = useStore();
    const route = useRoute();

    const divisions = ref([]);
    const bookGroup = computed(() => store.getters["ticketing/bookGroup"]);
    const book = computed(() => store.getters["ticketing/book"]);
    const pass = computed(() => store.getters["ticketing/pass"]);
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);
    const masterPass = computed(() => store.getters["ticketing/masterPass"]);

    const isCountdownType = computed(() =>
      passService.checkIsCountdownPass(masterPass.value)
    );

    const isValidPassAndCenteredQR = computed(
      () => props.isValidPassAndCenteredQR
    );

    const limitedAtMinusStartHour = computed(() => {
      // 有効化前でbook.user_XXX_atがある場合
      if (!pass.value.is_valid && book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.user_limited_at,
          masterBook.value.start_hour
        );
        // 有効化前でbook.user_XXX_atがない場合
      } else if (!pass.value.is_valid && !book.value.user_started_at) {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          book.value.available_limited_at,
          masterBook.value.start_hour
        );
        // 有効化後
      } else {
        return myTicketsCommonService.getDiffLimitedAtMinusStartHour(
          pass.value.user_limited_at,
          masterBook.value.start_hour
        );
      }
    });

    onMounted(() => {
      divisions.value = bookGroupService.divisionArrange(bookGroup.value.books);
    });

    return {
      divisions,
      book,
      pass,
      masterBook,
      isCountdownType,
      limitedAtMinusStartHour,
      isValidPassAndCenteredQR,
      upperColors: props.upperColors,
    };
  },
};
</script>

<style lang="scss" scoped>
.centered-qr-content {
  padding: 6.13vw 4vw 4vw 4vw;
}

.default-content {
  display: flex;
  flex-direction: column;
  align-items: start;
}

.column {
  margin-bottom: -6px;
}

.centered-qr-ticket-name-label {
  margin-bottom: 4vw;
}

.column .centered-qr-b-face-section-disp {
  margin-bottom: 4vw;
}

.column .centered-qr-bg-face-division-count-disp {
  margin-bottom: 4vw;
}
</style>
